import React from 'react';
import { CircularProgress, Backdrop } from '@material-ui/core';

export const LoadingSpinner = ({open}) =>
    <Backdrop style={{  zIndex: 999999 }} open={open}>
        <CircularProgress />
    </Backdrop>
    